import { Component, OnInit } from '@angular/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-benefits-page',
  templateUrl: './benefits-page.component.html',
  styleUrls: ['./benefits-page.component.scss'],
})
export class BenefitsPageComponent implements OnInit {
  screenType = ScreenType;
  constructor() {}

  ngOnInit() {}
}
